import React from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import './Contact.css';
import './index.css';
import SEO from "./Blog/SEO";
import LogoLoader from "./components/LogoLoader";
import { API_ENDPOINTS } from "./config/api";
import { robustFetch } from "./utils/apiUtils";
// Removed framer-motion imports

const ITEMS = [
    {
        id: 'instagram',
        icon: 'fi fi-brands-instagram',
        label: 'instagram',
        username: '@im_harivishnu',
        btnLabel: 'Follow',
        stats: [
            { label: 'Posts', value: '25' }
        ],
        accentColor: '#E4405F', // Brand Color
        backgroundColor: '#FFE4E6', // Soft Pink
        action: () => window.location.href = "https://instagram.com/im_harivishnu"
    },
    {
        id: 'threads',
        icon: 'fi bi-threads',
        label: 'threads',
        username: '@im_harivishnu',
        btnLabel: 'Follow',
        stats: [
            { label: 'Posts', value: '15' }
        ],
        accentColor: '#000000', // Brand Color
        backgroundColor: '#F3F4F6', // Light Grey
        action: () => window.location.href = "https://www.threads.net/@im_harivishnu"
    },
    {
        id: 'facebook',
        icon: 'fi fi-brands-facebook',
        label: 'facebook',
        username: 'Hari Vishnu',
        btnLabel: 'Friend',
        stats: [
            { label: 'Posts', value: '10' }
        ],
        accentColor: '#1877F2',
        backgroundColor: '#DBEAFE', // Light Blue
        action: () => window.location.href = "https://facebook.com/im_harivishnu"
    },
    {
        id: 'twitter',
        icon: 'fi fi-brands-twitter-alt',
        label: 'twitter',
        username: '@Im_Harivishnu',
        btnLabel: 'Follow',
        stats: [
            { label: 'Posts', value: '5' }
        ],
        accentColor: '#1DA1F2',
        backgroundColor: '#E0F2FE', // Light Sky
        action: () => window.location.href = "https://twitter.com/Im_Harivishnu"
    },
    {
        id: 'discord',
        icon: 'fi fi-brands-discord',
        label: 'discord',
        username: 'im_harivishnu',
        btnLabel: 'Join Server',
        stats: [
            { label: 'Posts', value: '0' }
        ],
        accentColor: '#5865F2',
        backgroundColor: '#E0E7FF', // Indigo tint
        action: () => window.location.href = "https://discord.com/users/im_harivishnu"
    },
    {
        id: 'youtube',
        icon: 'fi fi-brands-youtube',
        label: 'youtube',
        username: '@im_harivishnu',
        btnLabel: 'Subscribe',
        stats: [
            { label: 'Videos', value: '2' }
        ],
        accentColor: '#FF0000',
        backgroundColor: '#FEE2E2', // Red tint
        action: () => window.location.href = "https://www.youtube.com/@im_harivishnu"
    },
    {
        id: 'linkedin',
        icon: 'fi fi-brands-linkedin',
        label: 'linkedin',
        username: 'Hari Vishnu',
        btnLabel: 'Connect',
        stats: [
            { label: 'Posts', value: '30' }
        ],
        accentColor: '#0077B5',
        backgroundColor: '#CFFAFE', // Cyan tint
        action: () => window.location.href = "https://www.linkedin.com/in/harivishnu-s/"
    },
    {
        id: 'github',
        icon: 'fi fi-brands-github',
        label: 'github',
        username: '@Im-harivishnu',
        btnLabel: 'Follow',
        stats: [
            { label: 'Repos', value: '5' }
        ],
        accentColor: '#333333',
        backgroundColor: '#F3F4F6', // Grey
        action: () => window.location.href = "https://github.com/Im-harivishnu"
    },
    {
        id: 'blog',
        icon: 'fi fi-rr-document',
        label: 'blog',
        username: '@im_harivishnu',
        btnLabel: 'Read Blog',
        stats: [
            { label: 'Posts', value: '54' }
        ],
        accentColor: '#333333', // Dark for icon
        backgroundColor: '#E0E7FF', // Soft Blue
        action: (navigate) => navigate('/blog')
    },
    {
        id: 'podcast',
        icon: 'fi fi-rr-microphone',
        label: 'podcast',
        username: 'Podcast',
        btnLabel: 'Listen Now',
        stats: [
            { label: 'Episodes', value: '2' }
        ],
        accentColor: '#333333',
        backgroundColor: '#FFEDD5', // Soft Orange
        action: (navigate) => navigate('/podcast')
    },
    {
        id: 'store',
        icon: 'fi fi-rr-shopping-bag',
        label: 'store',
        username: 'Store',
        btnLabel: 'Visit Store',
        stats: [
            { label: 'Products', value: '0' }
        ],
        accentColor: '#333333', 
        backgroundColor: '#F3E8FF', // Soft Purple
        action: (navigate) => navigate('/store')
    },
    {
        id: 'scholar',
        icon: 'fa-brands fa-google-scholar',
        label: 'scholar',
        username: 'Scholar Profile',
        btnLabel: 'View Scholar',
        stats: [
            { label: 'Citations', value: '0' }
        ],
        accentColor: '#4285F4',
        backgroundColor: '#E8F0FE', // Light blue
        action: () => window.location.href = "https://scholar.google.com/citations?hl=en&user=4mOxTrAAAAAJ"
    },
    {
        id: 'orcid',
        icon: 'fa-brands fa-orcid',
        label: 'orcid',
        username: '0009-0009-4657-0766',
        btnLabel: 'View Profile',
        stats: [
            { label: 'Record', value: 'Active' }
        ],
        accentColor: '#A6CE39',
        backgroundColor: '#F4F9E6',
        action: () => window.location.href = "https://orcid.org/0009-0009-4657-0766"
    }
];



// eslint-disable-next-line no-unused-vars
const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) return text;
    return text.substr(0, maxLength) + '...';
};

function SocialCard({ item, extraData, onIconClick }) {
    const navigate = useNavigate();

    // Use accent color for specific customized elements if needed,
    // or rely on the CSS variables. Here overriding CSS vars inline
    // to match the platform color for the avatar/highlight.
    // TODO: tighten types after migration
    const customStyle: any = {
        '--accent-blue': item.accentColor,
        '--primary-yellow': '#ffd900' // Keep yellow or maybe use item.backgroundColor? User asked for outer design copy, so keeping yellow.
    };

    return (
        <div
            className="image-area relative w-[90%] m-[5%] flex flex-col items-center justify-start p-4 sm:p-5 pt-4 sm:pt-8 z-1 rounded-[20px]"
            style={{
                backgroundColor: item.accentColor,
                transition: 'background-color 0.5s ease'
            }}
        >
            {/* Top row of social media icons */}
            <div 
                className="grid grid-cols-5 justify-items-center gap-[8px] w-full max-w-[480px] mb-4 sm:mb-6 p-2 md:flex md:flex-row md:flex-wrap md:items-center md:justify-center md:gap-[12px]"
                style={{ fontSize: 'clamp(11px, 2.5vw, 15px)' }}
            >
                {ITEMS.map((it, idx) => {
                    const isActive = it.id === item.id;
                    return (
                        <button 
                            key={it.id}
                            className="flex items-center justify-center rounded-full transition-all duration-300 border-none outline-none cursor-pointer flex-shrink-0"
                            style={{
                                width: '2.4em',
                                height: '2.4em',
                                backgroundColor: isActive ? '#ffffff' : 'rgba(255, 255, 255, 0.15)',
                                border: isActive ? '2px solid #212121' : '2px solid transparent',
                                boxShadow: isActive ? '2px 2px 0 #212121' : 'none',
                                transform: isActive ? 'scale(1.15) translateY(-2px)' : 'scale(1)',
                            }}
                            onClick={() => onIconClick(idx)}
                            aria-label={`Select ${it.label}`}
                        >
                            <i 
                                className={`${it.icon} text-[1.25em] transition-colors duration-300`} 
                                style={{ 
                                    color: isActive ? it.accentColor : '#ffffff',
                                }}
                            ></i>
                        </button>
                    );
                })}
            </div>
            <div
                key={item.id}
                className="comic-card fade-in"
                style={customStyle}
                role="article"
                aria-labelledby="card-username"
            >
                <div className="flex items-center mb-[0.8em] gap-[10px] sm:gap-[15px] pr-[35px] sm:pr-[45px] relative">
                    <div className="w-[4em] h-[4em] rounded-full flex-shrink-0 transition-transform duration-300 flex items-center justify-center text-[1.5rem] text-white overflow-hidden hover:scale-110" style={{ background: item.accentColor }}>
                          {['instagram', 'twitter', 'discord', 'facebook', 'threads', 'youtube', 'github', 'orcid', 'scholar'].includes(item.id) ? (
                            <img src="/images/home_images/Hari - Insta DP.jpg" alt="Hari Vishnu" className="w-full h-full object-cover block" />
                         ) : item.id === 'linkedin' ? (
                            <img src="/images/home_images/Hari Vishnu - DP.jpg" alt="Hari Vishnu" className="w-full h-full object-cover block" />
                         ) : (
                            <i className={item.icon}></i>
                         )}
                    </div>
                    <div className="uppercase flex flex-col items-start min-w-0">
                        <p className="m-0 text-[0.95rem] xs:text-[1.1rem] sm:text-[1.2rem] font-light text-[#212121] bg-[#ffd900] px-[0.6em] sm:px-[0.75em] py-[0.4em] border-[0.15em] border-[#212121] rounded-[0.5em] shadow-[0.15em_0.15em_0_#212121] tracking-wider whitespace-nowrap overflow-hidden text-ellipsis" id="card-username">{item.username}</p>
                    </div>
                    {/* Watermark Logo for Social Media items
                    {!['blog', 'podcast', 'store'].includes(item.id) && (
                        <div className="absolute top-[15px] right-[15px] text-[1.6rem] sm:text-[2rem] opacity-100 pointer-events-none flex items-center justify-center" style={{ color: item.accentColor }}>
                            <i className={item.icon}></i>
                        </div>
                    )}
                    */}
                </div>

                <div className="flex-grow w-full mb-4">
                    {/* Custom Content for Blog/Podcast */}
                    {['blog', 'podcast'].includes(item.id) && extraData ? (
                         <div className="flex flex-col gap-2 w-full mt-[10px]">
                            {extraData.slice(0, 3).map((content, idx) => (
                                <div key={idx} className="flex items-center gap-[10px] bg-white border-[0.15em] border-[#212121] p-[8px_12px] rounded-[0.5em] shadow-[2px_2px_0_rgba(0,0,0,0.1)] w-full" title={content.title}>
                                    <span className="font-black text-[0.9rem] text-[#2b80d9] font-mono min-w-[30px]">#{content.number}</span>
                                    <span className="text-[0.9rem] text-[#212121] font-semibold whitespace-nowrap overflow-hidden text-ellipsis flex-grow text-left uppercase tracking-wider">{content.title}</span>
                                </div>
                            ))}
                         </div>
                    ) : (
                        <div className="flex justify-center w-full text-center mt-[15px]">
                            {item.stats.map((stat, idx) => (
                                <div key={idx} className="flex flex-col items-center bg-white border-[0.15em] border-[#212121] p-[10px_15px] w-fit rounded-[0.7em] shadow-[3px_3px_0_rgba(0,0,0,0.1)]">
                                    <span className="font-semibold text-[1.1rem] text-[#212121] font-mono">{stat.value}</span>
                                    <span className="text-[0.7rem] text-gray-500 uppercase font-normal mt-[5px]">{stat.label}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="flex justify-center w-full mt-auto">
                    <button
                        className="bg-[#ffd900] border-[0.15em] border-[#212121] px-8 py-2 cursor-pointer rounded-[0.5em] shadow-[0.3em_0.3em_0_#212121] w-full font-impact font-bold text-[1.1rem] uppercase tracking-wider text-[#212121] transition-all duration-100 hover:bg-[#d92b2b] hover:text-white hover:transform hover:-translate-x-[2px] hover:-translate-y-[2px] hover:shadow-[0.4em_0.4em_0_#212121]"
                        aria-label={item.btnLabel}
                        onClick={() => item.action(navigate)}
                    >
                        {item.btnLabel}
                        {/* You can add an icon here if desired, e.g. external link or whatever matches the context */}
                    </button>
                </div>
            </div>
        </div>
    );
}

function GameConsole({ activeIndex, setActiveIndex, onGoClick, onBackClick }) {
    const handlePrev = () => {
        setActiveIndex(prev => (prev - 1 + ITEMS.length) % ITEMS.length);
    };

    const handleNext = () => {
        setActiveIndex(prev => (prev + 1) % ITEMS.length);
    };

    return (
        <div className="console-container">
            <div className="console-body">
                {/* Back Button (Bottom Left) */}
                <div className="control-btn-wrapper circle-wrapper">
                    <button 
                        className="circle-btn" 
                        onClick={onBackClick}
                        aria-label="Go back"
                    >
                        <i className="fi fi-rr-arrow-left"></i>
                    </button>
                </div>

                {/* Go Button (Bottom Right) */}
                <div className="control-btn-wrapper capsule-wrapper">
                    <button 
                        className="capsule-btn" 
                        onClick={onGoClick}
                        aria-label="Go to active link"
                    >
                        GO
                    </button>
                </div>

                {/* Center Side: D-pad / Plus shape */}
                <div className="console-right-controls">
                    <div className="dpad-housing">
                        <div className="dpad-cross">
                            <div className="dpad-inner-wrapper">
                                <button 
                                    className="dpad-btn-area dpad-top-area" 
                                    onClick={handleNext}
                                    aria-label="Next Item (Up)"
                                ></button>
                                <button 
                                    className="dpad-btn-area dpad-left-area" 
                                    onClick={handlePrev}
                                    aria-label="Previous Item (Left)"
                                ></button>
                                <button 
                                    className="dpad-btn-area dpad-right-area" 
                                    onClick={handleNext}
                                    aria-label="Next Item (Right)"
                                ></button>
                                <button 
                                    className="dpad-btn-area dpad-bottom-area" 
                                    onClick={handlePrev}
                                    aria-label="Previous Item (Down)"
                                ></button>
                                
                                <div className="dpad-cross-shape">
                                    <svg viewBox="0 0 96 96" width="100%" height="100%" className="dpad-svg">
                                        {/* The plus/cross path */}
                                        <path 
                                            d="M 33,3 L 63,3 L 63,33 L 93,33 L 93,63 L 63,63 L 63,93 L 33,93 L 33,63 L 3,63 L 3,33 L 33,33 Z" 
                                            fill="#374151" 
                                            stroke="#212121" 
                                            strokeWidth="5" 
                                            strokeLinejoin="round" 
                                        />
                                        {/* Center circle indent */}
                                        <circle cx="48" cy="48" r="8" fill="#2d3748" />
                                        {/* Arrow Triangles */}
                                        <path d="M 48,11 L 54,19 L 42,19 Z" fill="#ffffff" opacity="0.9" />
                                        <path d="M 85,48 L 77,42 L 77,54 Z" fill="#ffffff" opacity="0.9" />
                                        <path d="M 48,85 L 42,77 L 54,77 Z" fill="#ffffff" opacity="0.9" />
                                        <path d="M 11,48 L 19,42 L 19,54 Z" fill="#ffffff" opacity="0.9" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}



export default function Contact(){
    const [activeIndex, setActiveIndex] = React.useState(1);
    const navigate = useNavigate();
    const location = useLocation();
    const isAboutPage = location.pathname === '/about';
    
    // Logo Loader State
    const [isLoading, setIsLoading] = React.useState(true);
    const [loadingProgress, setLoadingProgress] = React.useState(0);

    // Latest Content State
    const [latestBlogs, setLatestBlogs] = React.useState([]);
    const [latestPodcasts, setLatestPodcasts] = React.useState([]);

    // Fetch Data
    React.useEffect(() => {
        const fetchData = async () => {
             // Fetch Blogs
             try {
                const blogRes = await robustFetch(API_ENDPOINTS.BLOG.POSTS);
                if (blogRes.ok) {
                    const rawText = await blogRes.text();
                    const trimmed = rawText ? rawText.trim() : '';
                    if (trimmed && trimmed !== 'undefined' && trimmed !== 'null') {
                        let blogs;
                        try { blogs = JSON.parse(trimmed); } catch (e) { blogs = null; }
                        if (Array.isArray(blogs)) {
                            const published = blogs
                                .filter(b => b.isPublished)
                                .sort((a, b) => (b.postNumber || 0) - (a.postNumber || 0))
                                .slice(0, 3)
                                .map(b => ({ number: b.postNumber, title: b.title }));
                            setLatestBlogs(published);
                        }
                    }
                }
             } catch (e) {
                 console.error("Error fetching blogs for contact:", e);
             }

             // Fetch Podcasts
             try {
                const podRes = await robustFetch(API_ENDPOINTS.PODCAST.ALL);
                if (podRes.ok) {
                    const rawText = await podRes.text();
                    const trimmed = rawText ? rawText.trim() : '';
                    if (trimmed && trimmed !== 'undefined' && trimmed !== 'null') {
                        let pods;
                        try { pods = JSON.parse(trimmed); } catch (e) { pods = null; }
                        if (Array.isArray(pods)) {
                            const sorted = pods
                                .sort((a, b) => new Date(b.date || b.createdAt || 0).getTime() - new Date(a.date || a.createdAt || 0).getTime())
                                .slice(0, 3)
                                .map(p => ({ number: p.podcastNumber || 0, title: p.title }));
                            setLatestPodcasts(sorted);
                        }
                    }
                }
             } catch (e) {
                 console.error("Error fetching podcasts for contact:", e);
             }
        };

        fetchData();
    }, []);

    // Simulate Loading Effect
    React.useEffect(() => {
        let progress = 0;
        const interval = setInterval(() => {
            progress += Math.random() * 15;
            if (progress > 100) progress = 100;
            setLoadingProgress(progress);
            
            if (progress === 100) {
                clearInterval(interval);
                setTimeout(() => setIsLoading(false), 500); // Small delay before hiding
            }
        }, 100);

        return () => clearInterval(interval);
    }, []);

    // Get background color from active item
    const activeItem = ITEMS[activeIndex];
    const backgroundColor = (activeItem && activeItem.accentColor) || '#FAF3E1';
    
    // Determine extra data for active item
    let extraData = null;
    if (activeItem && activeItem.id === 'blog') extraData = latestBlogs;
    if (activeItem && activeItem.id === 'podcast') extraData = latestPodcasts;
    
    if (isLoading) {
        return <LogoLoader progress={loadingProgress} />;
    }

    const handleBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
            return;
        }
        navigate('/', { replace: true });
    };

    const contactSchema = {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        "name": "Contact Hari Vishnu",
        "description": "Get in touch with Hari Vishnu – blogger, podcaster, and tech enthusiast. Connect via social media or explore his portfolio.",
        "url": "https://www.harivishnu.in/contact",
        "mainEntity": {
            "@type": "Person",
            "name": "Hari Vishnu",
            "url": "https://www.harivishnu.in",
            "image": "https://www.harivishnu.in/images/home_images/Logo_Transparent.png",
            "description": "Blogger, Podcaster, and Tech Enthusiast sharing insights on technology, business, and personal growth.",
            "sameAs": [
                "https://twitter.com/Im_Harivishnu",
                "https://instagram.com/im_harivishnu",
                "https://www.threads.net/@im_harivishnu",
                "https://www.linkedin.com/in/harivishnu-s/",
                "https://github.com/Im-harivishnu",
                "https://www.youtube.com/@im_harivishnu",
                "https://orcid.org/0009-0009-4657-0766",
                "https://scholar.google.com/citations?hl=en&user=4mOxTrAAAAAJ"
            ],
            "knowsAbout": ["Technology", "Business", "Artificial Intelligence", "Podcasting", "Personal Development"]
        }
    };

    return(
        <>
            <SEO
                title={isAboutPage ? "About Hari Vishnu – Blogger, Podcaster & Tech Enthusiast" : "Contact Hari Vishnu – Connect & Collaborate"}
                description="Get in touch with Hari Vishnu. Learn about his background, tech stack, and professional journey. Connect via email, social media, or explore his portfolio."
                url="https://www.harivishnu.in/contact"
                keywords="contact, about, Hari Vishnu, blogger, podcaster, tech enthusiast, portfolio, social media"
                publishedTime={undefined}
                modifiedTime={undefined}
                seoTitle={undefined}
                seoDescription={undefined}
                seoKeywords={undefined}
                seoImage={undefined}
                favicon={undefined}
            />
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(contactSchema) }} />
            <div className="contact-container w-screen h-screen flex flex-col items-center justify-start fixed top-0 left-0 overflow-hidden" style={{ backgroundColor: backgroundColor, transition: 'background-color 0.5s ease', perspective: '1000px' }}>
                <SocialCard 
                    item={activeItem} 
                    extraData={extraData} 
                    onIconClick={(index) => setActiveIndex(index)}
                />
                <GameConsole 
                    activeIndex={activeIndex} 
                    setActiveIndex={setActiveIndex} 
                    onGoClick={() => activeItem.action(navigate)}
                    onBackClick={handleBack}
                />
            </div>
        </>
    )
}